/**
 * Inventory Hub.
 *
 * Combines the asset inventory list and yard map into a single
 * tabbed page. The primary view for managing physical inventory.
 */

import { Package, MapPin } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import InventoryPage from "@/pages/InventoryPage";
import YardMapPage from "@/pages/YardMapPage";

const tabs = [
  { key: "list", label: "Inventory", icon: Package },
  { key: "yard-map", label: "Facility Map", icon: MapPin },
];

function InventoryHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "list");

  return (
    <div className="page-wide space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[var(--text-primary)]">
          Inventory Management
        </h2>
        <p className="mt-1 text-sm text-[var(--text-secondary)]">
          Manage assets, track physical locations, and monitor inventory health.
        </p>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "list" && <InventoryPage />}
      {activeTab === "yard-map" && <YardMapPage />}
    </div>
  );
}

export default InventoryHub;
